// src/hooks/useAuthRole.js
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../services/firebase";

export default function useAuthRole() {
  const [user, setUser] = useState(null);
  const [roles, setRoles] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      setUser(u || null);
      if (!u) { setRoles({}); setLoading(false); return; }
      try {
        const snap = await getDoc(doc(db, "roles", u.uid));
        setRoles(snap.exists() ? snap.data() : {});
      } catch {
        setRoles({});
      } finally {
        setLoading(false);
      }
    });
    return () => unsub();
  }, []);

  return { user, roles, loading };
}
